/**
 * i18n initialization for react-i18next.
 * Uses Prismic-built resources when available, fallback to static imports for all locales.
 * Following existing config pattern: getDefaultLocale from @config/i18n.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getDefaultLocale, getSupportedLocales } from '@config/i18n';

import { fallbackResources } from './fallbackResources';

const defaultLocale = getDefaultLocale();

let resources = fallbackResources;
try {
  const generated = require('../../generated/labels-resources.json');
  if (generated && typeof generated === 'object' && Object.keys(generated).length > 0) {
    resources = generated;
  }
} catch {
  // Use fallback when generated file does not exist (e.g. before first build or production edge case)
}

i18n.use(initReactI18next).init({
  resources,
  lng: defaultLocale,
  fallbackLng: defaultLocale,
  supportedLngs: getSupportedLocales(),
  lowerCaseLng: true,
  load: 'currentOnly',
  defaultNS: 'common',
  ns: ['common', 'seo', 'pricing'],
  initImmediate: false,
  debug: typeof process !== 'undefined' && process.env.NODE_ENV === 'development',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
  ...(typeof process !== 'undefined' && process.env.NODE_ENV === 'development' && {
    missingKeyHandler: (lng: string | string[], ns: string, key: string, fallbackValue: string) => {
      console.warn(`[i18n] Missing key: ${ns}:${key} for locale(s) ${Array.isArray(lng) ? lng.join(', ') : lng}`);
      return fallbackValue;
    },
  }),
});

if (!i18n.language || i18n.language !== defaultLocale) {
  i18n.language = defaultLocale;
}

export default i18n;
